var exports = {
  "k": "EmbedAudio.module__container___aWpOY2",
  "G": "EmbedAudio.module__deleteButton___aWpOY2",
};

module.exports = exports;
